import { apiGeneral, queryBuilder } from "services";

export function useCompany() {
  const getListCompany = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/companies?${queryString}`);
    return data.map((el: any) => ({
      name: el.trade_name,
      value: `${el.id}`,
    }));
  };
  const getListCompanyOldSelect = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/companies?${queryString}`);
    return data.map((el: any) => ({
      label: `${el.code} - ${el.trade_name}`,
      value: el.id,
    }));
  };
  return {
    getListCompany,
    getListCompanyOldSelect,
  };
}
